var React = require('react');

function GrowthplanLeaf (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.5","y":"0.5","width":"51","height":"51","rx":"25.5","stroke":"white","key":0}),React.createElement("path",{"d":"M29 23L17.75 34.25","stroke":"white","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M19.9999 32.0002C15.4999 24.5002 21.4999 17.0002 34.2499 17.7502C34.9999 30.5002 27.4999 36.5002 19.9999 32.0002Z","stroke":"white","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

GrowthplanLeaf.defaultProps = {"width":"52","height":"52","viewBox":"0 0 52 52","fill":"none"};

module.exports = GrowthplanLeaf;

GrowthplanLeaf.default = GrowthplanLeaf;
